import SubstanceValidationError from "../../js/entities/error/SubstanceValidationError.js";
import FormValidationError from "../../js/entities/error/FormValidationError.js";
import {Float} from "../../js/util/MathUtils.js";

export default class SubstanceDialogValidator {
    // Minimum mass of substance - the mass of proton.
    static #PROTON_EMW = 1.007825;
    #substanceRepository;
    #existingDisplayNames;

    /**
     * @param {SubstanceRepository} substanceRepository
     * @param {string[]} existingDisplayNames
     */
    init(substanceRepository, existingDisplayNames) {
        this.#substanceRepository = substanceRepository;
        this.#existingDisplayNames = existingDisplayNames;
    }

    /** @param {SubstanceDialogFormData} data */
    async validate(data) {
        const substanceJson = data.getSubstanceJson();
        // check if the display name is unique across substances in this injection
        this.#assertDisplayNameIsUnique(substanceJson.getDisplayName());
        // if molecular formula is not specified (only emw is present) then we can check if EMW is a number and its
        // value is between proton mass and max float32 value
        if (substanceJson.getMonoIsotopicMass() != null)
            this.#assertEmwIsValid(substanceJson.getMonoIsotopicMass());
        // and the last step is to send the validation request to the backend
        // it will check if alias contains any of restricted symbols, and the molecular formula is valid (if present)
        await this.#substanceRepository.validateSubstance(substanceJson);
    }

    /**
     * Checks if the display name is unique across other substance names in this injection
     * @param {string} displayName
     * @throws {SubstanceValidationError} if the name is already used
     */
    #assertDisplayNameIsUnique(displayName) {
        if (displayName != null && this.#existingDisplayNames.includes(displayName.toLowerCase()))
            throw new SubstanceValidationError([new FormValidationError('alias', `Already exists`)])
    }

    /**
     * Checks if the emw is a number and its value is between proton mass and max float32 value
     * @param {number} emw
     * @throws {SubstanceValidationError} if the emw is out of range
     */
    #assertEmwIsValid(emw) {
        if (emw < SubstanceDialogValidator.#PROTON_EMW)
            throw new SubstanceValidationError([new FormValidationError('mf', `Smaller than H`)]);
        if (emw > Float.maxValue().value)
            throw new SubstanceValidationError([new FormValidationError('mf', "Greater than 3.4e+38")]);
    }
}